module.exports = {"title":"Nemáte vybrané žádné datové bloky v ribbonu","subtitle":"Kliknutím do ribbonu si nastavíte bloky pro individuální podobu reportu."}